import React, { Component } from "react";
import { Grid, Typography, Link, Divider, Button, Box } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

import CustomDialog from "../layout/CustomDialog";
import LabeledTextField from "../layout/LabeledTextField";
import { validateEmail } from "../../services/utils/utils";
import usersService from "../../services/usersService";
import Swal from "sweetalert2";

const CONTACT_FIELD_LABEL_WIDTH = 100;
const CONTACT_FIELD_WIDTH = 250;

const CONTACT_DIALOG_TITLE_STYLE = {
  background: "#1e3d66",
  padding: "10px 16px"
};

const CONTACT_DIALOG_TITLE_TYPOGRAPHY_STYLE = {
  fontFamily: "\"Rubik\", \"Helvetica\", \"Arial\", sans-serif",
  fontSize: "18px",
  fontWeight: 700
};

const CONTACT_DIALOG_CONTENT_STYLE = {
  padding: "16px 18px 12px",
  background: "#ffffff"
};

const CONTACT_DIALOG_PAPER_STYLE = {
  borderRadius: 12,
  maxWidth: 720,
  overflow: "hidden",
  width: "100%"
};

class ContactUs extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    message: ""
  };

  render() {
    return (
      <CustomDialog
        label="צור קשר"
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="sm"
        paperClassName="contact-us-dialog"
        paperStyle={CONTACT_DIALOG_PAPER_STYLE}
        titleStyle={CONTACT_DIALOG_TITLE_STYLE}
        titleTypographyStyle={CONTACT_DIALOG_TITLE_TYPOGRAPHY_STYLE}
        contentStyle={CONTACT_DIALOG_CONTENT_STYLE}
        isContentDivided={false}
      >
        <Grid container direction="row" spacing={3} className="contact-us-body" alignItems="stretch">
          <Grid container item direction="column" spacing={2} xs={4} className="contact-us-info">
            <Grid item>
              <Typography className="contact-us-section-title" variant="h4">
                מידע ליצירת קשר
              </Typography>
            </Grid>
            <Grid item>
              <Typography className="contact-us-section-text" variant="subtitle1">
                אם יש לכם שאלה, הצעה או פידבק, נשמח מאוד לשמוע מכם.
                <br />
                כל מה שצריך לעשות הוא לבחור את דרך ההתקשרות שנוחה לכם, ואנחנו כאן בשבילכם.
              </Typography>
            </Grid>
            <Grid container item direction="column" className="contact-us-detail">
              <Grid item>
                <Typography className="contact-us-detail-label" variant="h5">
                  דוא״ל ליצירת קשר
                </Typography>
              </Grid>
              <Grid item>
                <Link className="contact-us-link" variant="subtitle1" href="mailto:Office@b-tax.co.il">
                  Office@b-tax.co.il
                </Link>
              </Grid>
            </Grid>
            <Grid container item direction="column" className="contact-us-detail">
              <Grid item>
                <Typography className="contact-us-detail-label" variant="h5">
                  מספר טלפון
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="contact-us-detail-value" variant="subtitle1">
                  050-592-7888
                </Typography>
              </Grid>
            </Grid>
            <Grid container item direction="column" className="contact-us-detail">
              <Grid item>
                <Typography className="contact-us-detail-label" variant="h5">
                  כתובת
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="contact-us-detail-value" variant="subtitle1">
                  ז׳בוטינסקי 61, פתח תקווה
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container item direction="row" xs={1} justify="center" className="contact-us-divider-wrap">
            <Divider orientation="vertical" flexItem className="contact-us-divider" />
          </Grid>

          <Grid container item direction="column" spacing={1} xs={7} className="contact-us-form">
            <Grid item>
              <Typography className="contact-us-section-title" variant="h4">
                כתוב לנו
              </Typography>
            </Grid>
            <Grid item>
              <LabeledTextField
                type="text"
                value={this.state.firstName}
                name="firstName"
                labelWidth={CONTACT_FIELD_LABEL_WIDTH}
                textFieldWidth={CONTACT_FIELD_WIDTH}
                label="שם פרטי"
                onChange={this.handleOnChange}
              />
            </Grid>
            <Grid item>
              <LabeledTextField
                type="text"
                value={this.state.lastName}
                name="lastName"
                labelWidth={CONTACT_FIELD_LABEL_WIDTH}
                textFieldWidth={CONTACT_FIELD_WIDTH}
                label="שם משפחה"
                onChange={this.handleOnChange}
              />
            </Grid>
            <Grid item>
              <LabeledTextField
                type="text"
                value={this.state.email}
                name="email"
                labelWidth={CONTACT_FIELD_LABEL_WIDTH}
                textFieldWidth={CONTACT_FIELD_WIDTH}
                label="דואר אלקטרוני"
                onChange={this.handleOnChange}
              />
            </Grid>
            <Grid item>
              <LabeledTextField
                type="text"
                value={this.state.mobile}
                name="mobile"
                labelWidth={CONTACT_FIELD_LABEL_WIDTH}
                textFieldWidth={CONTACT_FIELD_WIDTH}
                label="טלפון"
                onChange={this.handleOnChange}
              />
            </Grid>
            <Grid item>
              <LabeledTextField
                type="text"
                label="תוכן הפנייה"
                labelWidth={CONTACT_FIELD_LABEL_WIDTH}
                placeholder="כתוב לנו הודעה"
                value={this.state.message}
                name="message"
                multiline
                rows={6}
                textFieldWidth={CONTACT_FIELD_WIDTH}
                onChange={this.handleOnChange}
              />
            </Grid>
            <Grid item>
              <Box className="contact-us-actions">
                <Button
                  className="contact-us-send-button"
                  endIcon={<SendIcon />}
                  variant="contained"
                  onClick={this.sendMessage}
                >
                  שלח
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </CustomDialog>
    );
  }

  handleOnChange = (e) => {
    const val = e.target.value;
    this.setState({ ...this.state, [e.target.name]: val });
  };

  validateMessage = () => {
    const state = this.state;
    if (!state.firstName || !state.lastName) {
      Swal.fire("חסר שדות", "חסר השדות שם פרטי ושם משפחה", "warning");
      return;
    }
    if (state.mobile.length < 6) {
      Swal.fire("", "מספר הטפלון שהוזן אינו חוקי", "warning");
      return;
    }

    const message = String(state.message || "").trim();
    if (!message.length) {
      Swal.fire("", "לא הוזן תוכן הפנייה", "warning");
      return;
    }

    if (!validateEmail(state.email)) {
      Swal.fire("", "פורמט דוא\"ל לא חוקי", "warning");
      return;
    }

    // API still expects both subject and message; use the merged content for both.
    const subject = message.slice(0, 100);

    return {
      firstName: state.firstName,
      lastName: state.lastName,
      mobile: state.mobile,
      subject,
      message,
      email: state.email
    };
  };

  sendMessage = () => {
    const validatedData = this.validateMessage();
    if (!validatedData) return;
    usersService.informUsContactUsMsg(validatedData).then((res) => {
      if (res.success) {
        Swal.fire("בוצע", "פנייתך הגיע אלינו ונחזור אליך בקרוב", "success");
        this.setState({ firstName: "", lastName: "", email: "", mobile: "", message: "" });
      }
    });
  };
}

export default ContactUs;
